import { lowerFirst } from 'es-toolkit';

function createNonexistentProperty(keyName: string) {
  const throwNonexistentPropertyError = () => {
    throw new Error(`Property does not exist: ${keyName}`);
  };

  return {
    configurable: false,
    enumerable: false,
    get: throwNonexistentPropertyError,
    set: throwNonexistentPropertyError,
  };
}

function normalizeObjectKeys(sourceObject: any) {
  const transformedObject: any = {};

  for (const key of Object.keys(sourceObject)) {
    let newKey = key;

    if (lowerFirst(key) !== key) {
      newKey = key.length > 2 ? lowerFirst(key) : key.toLowerCase();
      Object.defineProperty(transformedObject, key, createNonexistentProperty(key));
    }

    if (newKey.endsWith('_ID')) {
      newKey = `${newKey.slice(0, newKey.indexOf('_ID'))}Id`;
    }

    transformedObject[newKey] = sourceObject[key];
  }

  return transformedObject;
}

export function normalizeObject(result: any): any {
  if (Array.isArray(result)) {
    return result.map(normalizeObject);
  }

  if (result != null && typeof result === 'object') {
    for (const key of Object.keys(result)) {
      result[key] = normalizeObject(result[key]);
    }

    return normalizeObjectKeys(result);
  }

  return result;
}
